/* ============================================================================
   Wholesale landing page — progressive enhancement only.
   ----------------------------------------------------------------------------
   Two jobs, nothing else:

   1. Hero quick-capture card -> prefill the real application form and scroll.
      The card is not a <form> and its inputs have no `name`, so nothing is
      submittable. With JS off the card's "jump to the detailed form" link
      still works and the buyer retypes three fields.

   2. Product-interest chips -> keep the existing free-text
      contact[Products of Interest] input in sync. The chips themselves have no
      `name` attribute and are never submitted, so the emailed application
      still carries exactly one value for this field. With JS off the plain
      text input is still there and still works.

   The FAQ accordion is <details>/<summary> and needs no JS.
   Everything is wrapped so a failure here can never block the form.
   ========================================================================= */
(function () {
    'use strict';

    /* ---------------------------------------------------------------------
       The real application form.
       `.wholesale-form-fields` only exists when contact-form.liquid's
       is_wholesale_form is true, so this cannot latch onto the ordinary
       contact form if one is ever added to the same page.
       ------------------------------------------------------------------ */
    function applicationForm() {
        var fields = document.querySelector('.wholesale-form-fields');
        return fields ? fields.closest('form') : null;
    }

    function fieldByName(form, name) {
        return form.querySelector('[name="contact[' + name + ']"]');
    }

    /* =====================================================================
       1. Hero quick-capture -> prefill + scroll
       ================================================================== */
    function initQuickCapture() {
        var card = document.querySelector('[data-wl-quick]');
        if (!card) return;

        var trigger = card.querySelector('[data-wl-quick-submit]');
        if (!trigger) return;

        var form = applicationForm();
        if (!form) {
            // No application form on the page — fall back to the anchor link.
            trigger.setAttribute('hidden', 'hidden');
            return;
        }

        trigger.addEventListener('click', function () {
            card.querySelectorAll('[data-wl-quick-field]').forEach(function (source) {
                var value = (source.value || '').trim();
                if (!value) return;

                var target = fieldByName(form, source.getAttribute('data-wl-quick-field'));
                if (!target) return;

                if (target.tagName === 'SELECT') {
                    // Only assign when the option actually exists, otherwise the
                    // select silently blanks. snippets/wholesale-business-types.liquid
                    // renders both lists so this should always match.
                    var match = Array.prototype.some.call(target.options, function (option) {
                        return option.value === value;
                    });
                    if (!match) return;
                }

                target.value = value;
                target.dispatchEvent(new Event('input', { bubbles: true }));
                target.dispatchEvent(new Event('change', { bubbles: true }));
            });

            form.scrollIntoView({ behavior: 'smooth', block: 'start' });

            // Focus the first required field the buyer still has to fill.
            var pending = Array.prototype.find.call(
                form.querySelectorAll('[required]'),
                function (el) {
                    return !el.value && el.type !== 'checkbox' && el.offsetParent !== null;
                }
            );
            if (pending) {
                // Defer so the smooth scroll is not cancelled by focus().
                window.setTimeout(function () {
                    pending.focus({ preventScroll: true });
                }, 500);
            }
        });
    }

    /* =====================================================================
       2. Product-interest chips <-> contact[Products of Interest]
       ================================================================== */
    function initInterestChips() {
        var group = document.querySelector('[data-wl-chips]');
        if (!group) return;

        var form = applicationForm();
        if (!form) return;

        var input = fieldByName(form, 'Products of Interest');
        if (!input) return;

        var boxes = Array.prototype.slice.call(group.querySelectorAll('[data-wl-interest]'));
        if (!boxes.length) return;

        var labels = boxes.map(function (box) {
            return box.getAttribute('data-wl-interest');
        });

        function tokens() {
            return (input.value || '')
                .split(',')
                .map(function (part) {
                    return part.trim();
                })
                .filter(Boolean);
        }

        function sync() {
            // Drop every chip label, then re-append the checked ones in chip
            // order. Anything the buyer typed themselves survives untouched.
            var kept = tokens().filter(function (token) {
                return labels.indexOf(token) === -1;
            });
            var checked = boxes
                .filter(function (box) {
                    return box.checked;
                })
                .map(function (box) {
                    return box.getAttribute('data-wl-interest');
                });
            input.value = kept.concat(checked).join(', ');
        }

        // Repopulate the chips from the input on load, so a validation error
        // round-trip does not lose the selection.
        var existing = tokens();
        boxes.forEach(function (box) {
            if (existing.indexOf(box.getAttribute('data-wl-interest')) !== -1) {
                box.checked = true;
            }
            box.addEventListener('change', sync);
        });
    }

    /* =====================================================================
       3. Bring the post-submit result into view

       Shopify redirects back to the page after a POST, but a URL fragment is
       never sent to the server, so the #ContactForm-<id> anchor on the form
       action cannot survive the round trip — the buyer lands at scrollY 0.
       On this landing page the form is ~7,700px down an ~11,900px page, so a
       correctly rendered confirmation is nowhere near the viewport and the
       buyer reasonably concludes nothing happened.

       The theme's own handler only scrolls on error, never on success.
       ================================================================== */
    function initFormResult() {
        var result = document.querySelector('[data-wl-form-result]');
        if (!result) return;

        // Let the theme's own formMessage() finish (it runs on a 400ms delay
        // and rewrites history), then move to the banner.
        window.setTimeout(function () {
            result.scrollIntoView({ behavior: 'smooth', block: 'center' });
            // Focus so screen readers and keyboard users land on the result
            // too; tabindex="-1" makes it focusable without adding a tab stop.
            result.focus({ preventScroll: true });
        }, 550);
    }

    function init() {
        try {
            initFormResult();
        } catch (e) {
            /* never block the form */
        }
        try {
            initQuickCapture();
        } catch (e) {
            /* never block the form */
        }
        try {
            initInterestChips();
        } catch (e) {
            /* never block the form */
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
